import { useEffect } from "react";
import { hideOthers } from "aria-hidden";
/**
 * Marks everything except given ref as aria-hidden
 */
export const useHideOtherDomElements = (ref, props) => {
    const { isActive } = props;
    useEffect(() => {
        if (!ref.current || !isActive) {
            return () => { };
        }
        return hideOthers(ref?.current);
    }, [isActive, ref]);
};
